import React from "react";

type BrandLogoProps = {
  size?: number;
  withText?: boolean;
  withTagline?: boolean;
  className?: string;
};

export default function BrandLogo({
  size = 36,
  withText = true,
  withTagline = false,
  className = "",
}: BrandLogoProps) {
  const wrapperClass = withText ? "brand-logo has-text" : "brand-logo";

  return (
    <div className={`${wrapperClass} ${className}`.trim()}>
      <span
        className="brand-logo-icon-frame"
        aria-hidden="true"
        style={{ width: `${size}px`, height: `${size}px` }}
      >
        <img
          src="/brand-icon.png"
          alt=""
          width={size}
          height={size}
          className="brand-logo-icon-image"
        />
      </span>
      {withText && (
        <div className="brand-logo-text">
          <div className="brand-logo-title">Ahorra y Respira</div>
          {withTagline && (
            <div className="brand-logo-tagline">Tu dinero, bien controlado</div>
          )}
        </div>
      )}
    </div>
  );
}
